// // components/checkout/CouponModal.jsx
// import React, { useState, useEffect } from "react";
// import { X, Percent, Tag, ChevronRight, Loader2 } from "lucide-react";
// import logo from "../../assets/Revibelogo.png";
// import { getAuthToken } from "../../api/auth";

// const BASE_URL = "https://stage.getrevibe.app/api";

// // ─── API helpers with authentication ────────────────────────────────────────────
// const getHeaders = () => {
//   const token = getAuthToken();
//   return {
//     "Content-Type": "application/json",
//     ...(token && { Authorization: `Bearer ${token}` }),
//   };
// };

// export const getCoupons = async (page = 1) => {
//   const response = await fetch(`${BASE_URL}/coupons?page=${page}&limit=10`, {
//     method: "GET",
//     headers: getHeaders(),
//   });

//   if (!response.ok) throw new Error("Failed to fetch coupons");
//   return response.json();
// };

// export const applyCoupon = async (code, amount) => {
//   const reqBody = { code, amount };

//   const response = await fetch(`${BASE_URL}/orders/apply-coupon`, {
//     method: "POST",
//     headers: getHeaders(),
//     body: JSON.stringify(reqBody),
//   });

//   if (!response.ok) {
//     const err = await response.json().catch(() => ({}));
//     throw new Error(err?.message || "Invalid coupon code");
//   }
//   return response.json();
// };

// export const redeemCoupon = async (razorpayOrderId, code) => {
//   const reqBody = { razorpay_order_id: razorpayOrderId, code };

//   const response = await fetch(`${BASE_URL}/orders/redeem-coupon`, {
//     method: "POST",
//     headers: getHeaders(),
//     body: JSON.stringify(reqBody),
//   });

//   if (!response.ok) {
//     const err = await response.json().catch(() => ({}));
//     throw new Error(err?.message || "Failed to redeem coupon");
//   }
//   return response.json();
// };

// // ─── Component ───────────────────────────────────────────────────────────────
// const CouponModal = ({
//   isOpen,
//   onClose,
//   amount,
//   onCouponApplied,
//   razorpayOrderId,
// }) => {
//   const [couponCode, setCouponCode] = useState("");
//   const [coupons, setCoupons] = useState([]);
//   const [loadingCoupons, setLoadingCoupons] = useState(false);
//   const [applying, setApplying] = useState(false);
//   const [error, setError] = useState("");
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [redeeming, setRedeeming] = useState(false);
//   const [redeemed, setRedeemed] = useState(false);

//   // Fetch available coupons when modal opens
//   useEffect(() => {
//     if (!isOpen) return;
    
//     const fetchCoupons = async () => {
//       setLoadingCoupons(true);
//       setError("");
//       try {
//         const data = await getCoupons();
//         setCoupons(data?.coupons ?? []);
//       } catch (err) {
//         console.error("Failed to fetch coupons:", err);
//         setCoupons([]);
//         setError("Failed to load available coupons");
//       } finally {
//         setLoadingCoupons(false);
//       }
//     };

//     fetchCoupons();
//   }, [isOpen]);

//   // Auto-redeem once razorpayOrderId is available and a coupon is applied
//   useEffect(() => {
//     if (!razorpayOrderId || !appliedCoupon || redeemed) return;
    
//     const performRedeem = async () => {
//       setRedeeming(true);
//       try {
//         await redeemCoupon(razorpayOrderId, appliedCoupon.code);
//         setRedeemed(true);
//         onCouponApplied?.(appliedCoupon.code, appliedCoupon.discountAmount, true);
//       } catch (e) {
//         setError(e.message);
//         onCouponApplied?.(appliedCoupon.code, appliedCoupon.discountAmount, false);
//       } finally {
//         setRedeeming(false);
//       }
//     };

//     performRedeem();
//   }, [razorpayOrderId, appliedCoupon, redeemed, onCouponApplied]);

//   // Reset state when modal closes
//   useEffect(() => {
//     if (!isOpen) {
//       setCouponCode("");
//       setError("");
//       setAppliedCoupon(null);
//       setRedeemed(false);
//     }
//   }, [isOpen]);

//   if (!isOpen) return null;

//   const handleApply = async (code = couponCode) => {
//     const trimmed = code.trim().toUpperCase();
//     if (!trimmed) {
//       setError("Please enter a coupon code.");
//       return;
//     }
    
//     setError("");
//     setApplying(true);
    
//     try {
//       const data = await applyCoupon(trimmed, amount);
//       const discount = parseFloat(data?.discount ?? 0);
//       const applied = { code: trimmed, discountAmount: discount };
//       setAppliedCoupon(applied);
      
//       // If razorpayOrderId is already available, redeem immediately
//       if (razorpayOrderId) {
//         setRedeeming(true);
//         try {
//           await redeemCoupon(razorpayOrderId, trimmed);
//           setRedeemed(true);
//           onCouponApplied?.(trimmed, discount, true);
//         } catch (e) {
//           setError(e.message);
//           onCouponApplied?.(trimmed, discount, false);
//         } finally {
//           setRedeeming(false);
//         }
//       } else {
//         onCouponApplied?.(trimmed, discount, true);
//       }
      
//       onClose();
//     } catch (e) {
//       setError(e.message || "Invalid coupon code. Please try again.");
//     } finally {
//       setApplying(false);
//     }
//   };

//   const selectCoupon = (code) => {
//     setCouponCode(code.toUpperCase());
//     setError("");
//   };

//   // Format discount display
//   const formatDiscount = (coupon, amount) => {
//     if (coupon.type === "Flat") {
//       return `₹${coupon.value} OFF`;
//     } else if (coupon.type === "Percent") {
//       return `${coupon.value}% OFF`;
//     }
//     return "Save";
//   };

//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center px-4"
//       style={{ backgroundColor: "rgba(0,0,0,0.75)" }}
//       onClick={onClose}
//     >
//       <div
//         className="relative w-full max-w-sm rounded-3xl p-8 bg-white"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Close */}
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
//         >
//           <X size={22} />
//         </button>

//         {/* Logo */}
//         <div className="flex items-center justify-center gap-2 mb-6">
//           <img src={logo} alt="Revibe logo" className="h-9" />
//         </div>

//         {/* Heading */}
//         <h2 className="text-lime-500 text-xl font-bold text-center mb-1">
//           Have a Coupon Code?
//         </h2>
//         <p className="text-gray-500 text-sm text-center mb-6">
//           Get exclusive discounts
//         </p>

//         {/* Input */}
//         <div
//           className="flex items-center gap-3 rounded-2xl px-4 py-3 mb-2"
//           style={{ border: "1.5px solid #d1d5db", backgroundColor: "#f9fafb" }}
//         >
//           <Percent size={20} className="text-gray-400 shrink-0" />
//           <input
//             type="text"
//             placeholder="Enter coupon code"
//             value={couponCode}
//             onChange={(e) => {
//               setCouponCode(e.target.value.toUpperCase());
//               setError("");
//             }}
//             onKeyDown={(e) => e.key === "Enter" && handleApply()}
//             className="flex-1 bg-transparent text-gray-800 placeholder-gray-400 text-base focus:outline-none"
//           />
//         </div>

//         {/* Error */}
//         {error && (
//           <p className="text-red-500 text-xs text-center mb-3">{error}</p>
//         )}

//         {/* Success */}
//         {appliedCoupon && !redeeming && redeemed && (
//           <p className="text-green-500 text-sm text-center mb-3 font-semibold">
//             ✓ Coupon applied! You saved ₹{appliedCoupon.discountAmount}
//           </p>
//         )}

//         {/* Redeeming indicator */}
//         {redeeming && (
//           <p className="text-gray-400 text-xs text-center mb-3 flex items-center justify-center gap-1">
//             <Loader2 size={12} className="animate-spin" /> Redeeming coupon…
//           </p>
//         )}

//         {/* Apply button */}
//         <button
//           onClick={() => handleApply()}
//           disabled={applying}
//           className="w-full py-4 bg-lime-400 hover:bg-lime-500 disabled:opacity-60 text-black font-bold rounded-full transition duration-300 mb-4 flex items-center justify-center gap-2"
//         >
//           {applying ? (
//             <>
//               <Loader2 size={18} className="animate-spin" />
//               Applying…
//             </>
//           ) : (
//             "Apply Coupon"
//           )}
//         </button>

//         {/* Available coupons list */}
//         {loadingCoupons ? (
//           <div className="flex justify-center py-2">
//             <Loader2 size={20} className="animate-spin text-lime-400" />
//           </div>
//         ) : coupons.length > 0 ? (
//           <div className="mb-4">
//             <p className="text-gray-400 text-xs font-semibold uppercase tracking-wide mb-2">
//               Available Coupons
//             </p>
//             <div className="flex flex-col gap-2 max-h-40 overflow-y-auto">
//               {coupons.map((coupon) => (
//                 <button
//                   key={coupon.code ?? coupon._id}
//                   onClick={() => selectCoupon(coupon.code)}
//                   className="flex items-center justify-between rounded-xl px-4 py-3 bg-lime-50 border border-lime-200 hover:bg-lime-100 transition text-left"
//                 >
//                   <div className="flex items-center gap-2">
//                     <Tag size={15} className="text-lime-500 shrink-0" />
//                     <div>
//                       <p className="text-gray-800 font-bold text-sm">
//                         {coupon.code}
//                       </p>
//                       {coupon.description && (
//                         <p className="text-gray-400 text-xs">
//                           {coupon.description}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                   <div className="flex items-center gap-1">
//                     <span className="text-lime-600 text-xs font-semibold">
//                       {formatDiscount(coupon, amount)}
//                     </span>
//                     <ChevronRight size={15} className="text-lime-400" />
//                   </div>
//                 </button>
//               ))}
//             </div>
//           </div>
//         ) : null}

//         {/* Skip */}
//         <button
//           onClick={onClose}
//           className="w-full text-center text-gray-500 text-sm hover:text-gray-700 transition"
//         >
//           Skip for now
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CouponModal;

// components/checkout/CouponModal.jsx
import React, { useState, useEffect } from "react";
import { X, Percent, Tag, ChevronRight, Loader2 } from "lucide-react";
import logo from "../../assets/Revibelogo.png";
import { getCoupons, applyCoupon, redeemCoupon } from "../../api/coupon";

// ─── Component ───────────────────────────────────────────────────────────────
const CouponModal = ({
  isOpen,
  onClose,
  amount,
  onCouponApplied,
  razorpayOrderId,
}) => {
  const [couponCode, setCouponCode] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [loadingCoupons, setLoadingCoupons] = useState(false);
  const [applying, setApplying] = useState(false);
  const [error, setError] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [redeeming, setRedeeming] = useState(false);
  const [redeemed, setRedeemed] = useState(false);

  // Fetch available coupons when modal opens
  useEffect(() => {
    if (!isOpen) return;

    const fetchCoupons = async () => {
      setLoadingCoupons(true);
      setError("");
      try {
        const data = await getCoupons();
        setCoupons(data?.coupons ?? []);
      } catch (err) {
        console.error("Failed to fetch coupons:", err);
        setCoupons([]);
        setError("Failed to load available coupons");
      } finally {
        setLoadingCoupons(false);
      }
    };

    fetchCoupons();
  }, [isOpen]);

  // Auto-redeem once razorpayOrderId is available and a coupon is applied
  useEffect(() => {
    if (!razorpayOrderId || !appliedCoupon || redeemed) return;

    const performRedeem = async () => {
      setRedeeming(true);
      try {
        await redeemCoupon(razorpayOrderId, appliedCoupon.code);
        setRedeemed(true);
        onCouponApplied?.(appliedCoupon.code, appliedCoupon.discountAmount, true);
      } catch (e) {
        setError(e.message);
        onCouponApplied?.(appliedCoupon.code, appliedCoupon.discountAmount, false);
      } finally {
        setRedeeming(false);
      }
    };

    performRedeem();
  }, [razorpayOrderId, appliedCoupon, redeemed, onCouponApplied]);

  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setCouponCode("");
      setError("");
      setAppliedCoupon(null);
      setRedeemed(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleApply = async (code = couponCode) => {
    const trimmed = code.trim().toUpperCase();
    if (!trimmed) {
      setError("Please enter a coupon code.");
      return;
    }

    setError("");
    setApplying(true);

    try {
      const data = await applyCoupon(trimmed, amount);
      const discount = parseFloat(data?.discount ?? 0);
      const applied = { code: trimmed, discountAmount: discount };
      setAppliedCoupon(applied);

      // If razorpayOrderId is already available, redeem immediately
      if (razorpayOrderId) {
        setRedeeming(true);
        try {
          await redeemCoupon(razorpayOrderId, trimmed);
          setRedeemed(true);
          onCouponApplied?.(trimmed, discount, true);
        } catch (e) {
          setError(e.message);
          onCouponApplied?.(trimmed, discount, false);
        } finally {
          setRedeeming(false);
        }
      } else {
        onCouponApplied?.(trimmed, discount, true);
      }

      onClose();
    } catch (e) {
      setError(e.message || "Invalid coupon code. Please try again.");
    } finally {
      setApplying(false);
    }
  };

  const selectCoupon = (code) => {
    setCouponCode(code.toUpperCase());
    setError("");
  };

  const formatDiscount = (coupon) => {
    if (coupon.type === "Flat") return `₹${coupon.value} OFF`;
    if (coupon.type === "Percent") return `${coupon.value}% OFF`;
    return "Save";
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ backgroundColor: "rgba(0,0,0,0.75)" }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-3xl p-8 bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
        >
          <X size={22} />
        </button>

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <img src={logo} alt="Revibe logo" className="h-9" />
        </div>

        {/* Heading */}
        <h2 className="text-lime-500 text-xl font-bold text-center mb-1">
          Have a Coupon Code?
        </h2>
        <p className="text-gray-500 text-sm text-center mb-6">
          Get exclusive discounts
        </p>

        {/* Input */}
        <div
          className="flex items-center gap-3 rounded-2xl px-4 py-3 mb-2"
          style={{ border: "1.5px solid #d1d5db", backgroundColor: "#f9fafb" }}
        >
          <Percent size={20} className="text-gray-400 shrink-0" />
          <input
            type="text"
            placeholder="Enter coupon code"
            value={couponCode}
            onChange={(e) => {
              setCouponCode(e.target.value.toUpperCase());
              setError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleApply()}
            className="flex-1 bg-transparent text-gray-800 placeholder-gray-400 text-base focus:outline-none"
          />
        </div>

        {/* Error */}
        {error && (
          <p className="text-red-500 text-xs text-center mb-3">{error}</p>
        )}

        {/* Success */}
        {appliedCoupon && !redeeming && redeemed && (
          <p className="text-green-500 text-sm text-center mb-3 font-semibold">
            ✓ Coupon applied! You saved ₹{appliedCoupon.discountAmount}
          </p>
        )}

        {/* Redeeming indicator */}
        {redeeming && (
          <p className="text-gray-400 text-xs text-center mb-3 flex items-center justify-center gap-1">
            <Loader2 size={12} className="animate-spin" /> Redeeming coupon…
          </p>
        )}

        {/* Apply button */}
        <button
          onClick={() => handleApply()}
          disabled={applying}
          className="w-full py-4 bg-lime-400 hover:bg-lime-500 disabled:opacity-60 text-black font-bold rounded-full transition duration-300 mb-4 flex items-center justify-center gap-2"
        >
          {applying ? (
            <>
              <Loader2 size={18} className="animate-spin" />
              Applying…
            </>
          ) : (
            "Apply Coupon"
          )}
        </button>

        {/* Available coupons list */}
        {loadingCoupons ? (
          <div className="flex justify-center py-2">
            <Loader2 size={20} className="animate-spin text-lime-400" />
          </div>
        ) : coupons.length > 0 ? (
          <div className="mb-4">
            <p className="text-gray-400 text-xs font-semibold uppercase tracking-wide mb-2">
              Available Coupons
            </p>
            <div className="flex flex-col gap-2 max-h-40 overflow-y-auto">
              {coupons.map((coupon) => (
                <button
                  key={coupon.code ?? coupon._id}
                  onClick={() => selectCoupon(coupon.code)}
                  className="flex items-center justify-between rounded-xl px-4 py-3 bg-lime-50 border border-lime-200 hover:bg-lime-100 transition text-left"
                >
                  <div className="flex items-center gap-2">
                    <Tag size={15} className="text-lime-500 shrink-0" />
                    <div>
                      <p className="text-gray-800 font-bold text-sm">
                        {coupon.code}
                      </p>
                      {coupon.description && (
                        <p className="text-gray-400 text-xs">
                          {coupon.description}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="text-lime-600 text-xs font-semibold">
                      {formatDiscount(coupon)}
                    </span>
                    <ChevronRight size={15} className="text-lime-400" />
                  </div>
                </button>
              ))}
            </div>
          </div>
        ) : null}

        {/* Skip */}
        <button
          onClick={onClose}
          className="w-full text-center text-gray-500 text-sm hover:text-gray-700 transition"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
};

export default CouponModal;